import React from "react";
import { useSidebarStore } from "../SidebarStore";
import { useSelf } from "@/hooks/useSelf";

export function useSidebarFavorites() {
  const self = useSelf();
  const userId = self.data?.id ?? "anonymous";

  const showFavoritesOnly = useSidebarStore((state) => state.showFavoritesOnly[userId] ?? false);
  const setShowFavoritesOnly = useSidebarStore((state) => state.setShowFavoritesOnly);

  const setIsFavoritesOnly = React.useCallback(
    (value: boolean) => {
      setShowFavoritesOnly(userId, value);
    },
    [userId, setShowFavoritesOnly],
  );

  const toggleFavorites = React.useCallback(() => {
    setIsFavoritesOnly(!showFavoritesOnly);
  }, [showFavoritesOnly, setIsFavoritesOnly]);

  return {
    isShowingFavoritesOnly: showFavoritesOnly,
    toggleFavorites,
  };
}
